module.exports = __webpack_public_path__ + "img/dnd_2_splash.924a47a9.jpg";